import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { getList } from "./SummaryAPI";
//import { startOfQuarter } from 'date-fns';

const initialState = {
    summaryList: [],
    prj: {},
    apiStatus: 'idle'
}

export const getSummaryListAsync = createAsyncThunk(
    'summary/getList',
    async (input, thunkAPI) => {
        //const response = await login(input);
        let res;
        try {
            res = getList(input);
        } catch (e) {
            thunkAPI.rejectWithValue({ errorMessage: 'Fetch error' });
            return;
        }

        //return response.data;
        return res;
    }
);

const summaryListSlice = createSlice({
    name: "summary",
    initialState,
    reducers: {
        selectCurrentPrj: (state, action) => {
            state.prj = action.payload.prj;
        },
        unselectCurrentPrj: (state) => {
            state.prj = {};
        },
    },

    extraReducers: (builder) => {
        builder
            .addCase(getSummaryListAsync.pending, (state) => {
                state.apiStatus = 'loading';
            })
            .addCase(getSummaryListAsync.fulfilled, (state, action) => {
                state.apiStatus = 'idle';
                //if (Boolean(action.payload.success)) {
                state.summaryList = action.payload;
                //}
            })
            .addCase(getSummaryListAsync.rejected, (state, action) => {
                state.apiStatus = 'idle';
                state.prj = {};
                state.summaryList = {};
            });
    },
});


export const selectSummaryList = (state) => state.summary.summaryList;

//export const selectPrjId = (state) => state.summary.prjId;
//export const selectPrjName = (state) => state.summary.prjName;
//export const selectAwsId = (state) => state.summary.AwsId;

export const selectPrj = (state) => state.summary.prj;

export const { selectCurrentPrj, unselectCurrentPrj } = summaryListSlice.actions;

export default summaryListSlice;